import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdAndTravelType, getUserDetails, showAlert } from "../../Services/Shared.service";
import { createPackage, getPackage, getTaxGroupList } from "../../Services/Packages.service";
import { createCorporateClient, getCorporateClient, updateCorporateClient } from "../../Services/CorporateClient.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { createCoupon, updateCoupon } from "../../Services/Coupons.service";

const CouponInput = ({ cityData, editId, setIsOpen, fetchTableData, isOpen, couponObj, setCouponObj }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset
    } = useForm({
        defaultValues: {
            isActive: false,
            serviceCity: "",
            code: "",
            title: "",
            description: "",
            isApplicableForOldUser: false,
            validFrom: new Date(),
            validUpto: new Date(),
            isVisible: false,
            value: "",
            valueType: "",
            bookingSource: "",
            rideType: "",
            creditOrDebit: "",
        },
    });
    const values = getValues()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { mix_background_layout } = useContext(CustomizerContext)

    const bookingSourceData = [
        { value: "CUSTOMER", label: "CUSTOMER" },
        { value: "KIOSK", label: "KIOSK" },
        { value: "WEBSITE", label: "WEBSITE" },
        { value: "TMS", label: "TMS" },
        { value: "THIRDPARTY", label: "THIRDPARTY" },
        { value: "ALL", label: "ALL" },
    ]

    const rideTypeData = [
        { value: "A2C", label: "A2C" },
        { value: "C2A", label: "C2A" },
        { value: "C2C", label: "C2C" },
        { value: "ALL", label: "ALL" },
    ]

    const valueTypeData = [
        { value: "percentage", label: "Percentage" },
        { value: "flatRate", label: "Amount" },
    ]

     const creditOrDebitData = [
          {  value: 'CREDIT', label: "Credit" },
        //   {  value: 'DEBIT', label: "Debit" },    
          {  value: 'NA', label: "N/A" }   
    ]

    const creditOrDebitField = useController({
        name:'creditOrDebit',
        control,
        rules: {
            required: {
                value: true,
                message: "Wallet-Ops is Required",
            },
        },
    }).field;

    const handlecreditOrDebitSelectChange = (data) => {
        creditOrDebitField.onChange(data.value)
    }

    const valueTypeField = useController({
        name: "valueType",
        control,
        rules: {
            required: {
                value: true,
                message: "Value Type is Required",
            },
        },
    }).field;

    const handleValueTypeSelectChange = (data) => {
        valueTypeField.onChange(data.value);
    };

    const bookingSourceField = useController({
        name: "bookingSource",
        control,
        rules: {
            required: {
                value: true,
                message: "Booking Source is Required",
            },
        },
    }).field;

    const handleBookingSourceSelectChange = (data) => {
        bookingSourceField.onChange(data.value);
    };

    const rideTypeField = useController({
        name: "rideType",
        control,
        rules: {
            required: {
                value: true,
                message: "Ride Type is Required",
            },
        },
    }).field;

    const handleRideTypeSelectChange = (data) => {
        rideTypeField.onChange(data.value);
    };

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    const handleServiceCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
    };

    const isActiveField = useController({
        name: "isActive",
        control,
    }).field;

    const isApplicableForOldUserField = useController({
        name: "isApplicableForOldUser",
        control,
    }).field;

    const isVisibleField = useController({
        name: "isVisible",
        control,
    }).field;

    const validFromField = useController({
        name: "validFrom",
        control,
        rules: {
            required: {
                value: true,
                message: "Valid From is Required",
            },
            validate: (value) => {
            const now = new Date();
            if (!value) return true;
            if (new Date(value) < now) {
                return "The selected 'Valid From' time cannot be in the past. Please choose a future time.";
            }
            return true;
        },
        },
    }).field;

    const handlevalidFrom = (data) => {
        validFromField.onChange(data);
    };
    const getValidFromMinTime = () => {
        const selectedDateTime = validFromField.value;

        if (selectedDateTime && selectedDateTime.toDateString() === new Date().toDateString()){
            return new Date();
        }
        return new Date().setHours(0,0,0,0);
    }

    const getValidFromMaxtime = () => {
        return new Date().setHours(23, 59, 59, 999);
    }

    const validUptoField = useController({
        name: "validUpto",
        control,
        rules: {
            required: {
                value: true,
                message: "Valid Upto Date is Required",
            },
            validate: (value) => {
            if (!value) return true;
            if (!validFromField.value) return true;

            const from = new Date(validFromField.value);
            const upto = new Date(value);
            if (upto < from) {
                return "Valid Upto Date must be after Valid From";
            }
            return true;
        },
        },
    }).field;

    const handleValidUpto = (data) => {
        const from = new Date(validFromField.value);
        const upto = new Date(data);
        if (upto <= from) {
          validUptoField.onChange(validFromField.value);
        } else {
        validUptoField.onChange(data);
        }
    };

    const getValidUptoMinTime = () => {
      if (
        validUptoField.value &&
        validFromField.value &&
        validUptoField.value.toDateString() === validFromField.value.toDateString()
      ) {
        return validFromField.value;
      }
      return new Date(0, 0, 0, 0, 0);
    };

    useEffect(() => {
        if (couponObj.id) {
            reset({
                isActive: couponObj?.isActive ? true : false,
                serviceCity: couponObj?.serviceCityId ? {id: couponObj?.serviceCityId} : "",
                code: couponObj?.code ? couponObj?.code : "",
                title: couponObj?.title ? couponObj?.title : "",
                description: couponObj?.description ? couponObj?.description : "",
                isApplicableForOldUser: couponObj?.isApplicableForOldUser ? true : false,
                validFrom: couponObj?.validFrom ? new Date(couponObj?.validFrom) : "",
                validUpto: couponObj?.validUpto ? new Date(couponObj?.validUpto) : "",
                isVisible: couponObj?.isVisible ? true : false,
                value: couponObj?.value ? couponObj?.value : "",
                valueType: couponObj?.valueType ? couponObj?.valueType : "",
                bookingSource: couponObj?.bookingSource ? couponObj?.bookingSource : "",
                rideType: couponObj?.couponRideType ? couponObj?.couponRideType : "",
                creditOrDebit: couponObj?.creditOrDebit ? couponObj?.creditOrDebit : "",
            })
        }
    }, [couponObj?.id])

    console.log("values", values)

    const onFormSubmit = (formValues) => {
        setIsSubmitting(true)
        const body = {
            code: formValues.code ? formValues.code : "",
            title: formValues.title ? formValues.title : "",
            description: formValues.description ? formValues.description : "",
            isActive: formValues.isActive ? true : false,
            isApplicableForOldUser: formValues.isApplicableForOldUser ? true : false,
            validFrom: new Date(formValues.validFrom),
            isVisible: formValues.isVisible ? true : false,
            value: formValues.value ? Number(formValues.value) : "",
            valueType: formValues.valueType ? formValues.valueType : "",
            rideCount: couponObj?.rideCount ? couponObj?.rideCount : null,
            validUpto: new Date(formValues.validUpto),
            serviceCityId: formValues.serviceCity?.id ? formValues.serviceCity.id : null,
            couponRideType: formValues.rideType ? formValues.rideType : "",
            bookingSource: formValues.bookingSource ? formValues.bookingSource : "",
            isDeleted: couponObj?.isDeleted ? couponObj?.isDeleted : false,
            createdById: couponObj?.createdById ? couponObj?.createdById : null,
            createdOn: couponObj?.createdOn ? couponObj?.createdOn : null,
            updatedById: couponObj?.updatedById ? couponObj?.updatedById : null,
            updatedOn: couponObj?.updatedOn ? couponObj?.updatedOn : null,
            creditOrDebit: formValues.creditOrDebit ? formValues.creditOrDebit : "",
        };
        if (couponObj?.id) {
            body["id"] = couponObj?.id
            updateCoupon(body)
                .then((result) => {
                    reset({
                        isActive: false,
                        serviceCity: "",
                        code: "",
                        title: "",
                        description: "",
                        isApplicableForOldUser: false,
                        validFrom: new Date(),
                        validUpto: new Date(),
                        isVisible: false,
                        value: "",
                        valueType: "",
                        bookingSource: "",
                        rideType: "",
                        creditOrDebit: "",
                    })
                    showAlert("success", "Coupon Updated Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    setIsOpen(false)
                    setCouponObj({})
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        } else {
            createCoupon(body)
                .then((result) => {
                    reset({
                        isActive: false,
                        serviceCity: "",
                        code: "",
                        title: "",
                        description: "",
                        isApplicableForOldUser: false,
                        validFrom: new Date(),
                        validUpto: new Date(),
                        isVisible: false,
                        value: "",
                        valueType: "",
                        bookingSource: "",
                        rideType: "",
                        creditOrDebit: "",
                    })
                    showAlert("success", "Coupon Created Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    setIsOpen(false)
                    setCouponObj({})
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        }
    };

    return (
        <CommonModal
            isOpen={isOpen}
            title={editId ? "Edit Coupon" : "Create Coupon"}
            toggler={() => {
                reset({
                    isActive: false,
                    serviceCity: "",
                    code: "",
                    title: "",
                    description: "",
                    isApplicableForOldUser: false,
                    validFrom: new Date(),
                    validUpto: new Date(),
                    isVisible: false,
                    value: "",
                    valueType: "",
                    bookingSource: "",
                    rideType: "",
                    creditOrDebit: "",
                })
                setIsOpen(!isOpen)
                setCouponObj({})
            }}
            size="xl"
        >
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Code</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("code", {
                                    required: {
                                        value: true,
                                        message: "Code is required",
                                    },
                                    onChange: (e) => {
                                        setValue("code", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.code?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Title</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("title", {
                                    required: {
                                        value: true,
                                        message: "Title is required",
                                    },
                                    onChange: (e) => {
                                        setValue("title", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.title?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Description</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("description", {
                                    required: {
                                        value: true,
                                        message: "Description is required",
                                    },
                                    onChange: (e) => {
                                        setValue("description", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.description?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="isActive"
                                type="checkbox"
                                checked={isActiveField.value}
                                onChange={(value) => isActiveField.onChange(value)}
                            />
                            <Label className="mb-0" for="isActive" >{"Is Active"}</Label>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="isApplicableForOldUser"
                                type="checkbox"
                                checked={isApplicableForOldUserField.value}
                                onChange={(value) => isApplicableForOldUserField.onChange(value)}
                            />
                            <Label className="mb-0" for="isApplicableForOldUser" >{"Is ApplicableForOldUser"}</Label>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Service City</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={serviceCityField?.value?.id ? cityData.find((element) => {
                                        return element?.value?.id === serviceCityField?.value?.id;
                                    }) : ""}
                                    isDisabled={couponObj?.id ? true : false}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handleServiceCitySelectChange}
                                    placeholder="Select City"
                                    options={cityData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.serviceCity?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Valid From</Label>
                        <Col lg="12">
                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                <DatePicker
                                    className="form-control datetimepicker-input digits"
                                    selected={validFromField.value}
                                    timeInputLabel="Time:"
                                    showTimeInput
                                    showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                    onChange={handlevalidFrom}
                                    dateFormat="MMMM d yyyy, h:mm:ss a"
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                    minDate = {new Date()}
                                    minTime = {getValidFromMinTime()}
                                    maxTime = {getValidFromMaxtime()}
                                />
                            </InputGroup>
                            <span style={{ color: "red" }}>{errors?.validFrom?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Valid Upto</Label>
                        <Col lg="12">
                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                <DatePicker
                                    className="form-control datetimepicker-input digits"
                                    selected={validUptoField.value}
                                    timeInputLabel="Time:"
                                    showTimeInput                          
                                    showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                    onChange={handleValidUpto}
                                    dateFormat="MMMM d yyyy, h:mm:ss a"
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                    minDate = {validFromField.value || new Date()}
                                    minTime = {getValidUptoMinTime()}
                                    maxTime = {getValidFromMaxtime()}
                                />
                            </InputGroup>
                            <span style={{ color: "red" }}>{errors?.validUpto?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="isVisible"
                                type="checkbox"
                                checked={isVisibleField.value}
                                onChange={(value) => isVisibleField.onChange(value)}
                            />
                            <Label className="mb-0" for="isVisible" >{"Is Visible"}</Label>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Value</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("value", {
                                    required: {
                                        value: true,
                                        message: "Value is required",
                                    },
                                    onChange: (e) => {
                                        setValue("value", e.target.value.replace(/[^0-9]/g, ''))
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.value?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Value Type</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <Select
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={valueTypeField?.value ? valueTypeData.find((element) => {
                                        return element?.value === valueTypeField?.value;
                                    }) : ""}
                                    onChange={handleValueTypeSelectChange}
                                    placeholder="Select Value Type"
                                    options={valueTypeData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.valueType?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Ride Type</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <Select
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={rideTypeField?.value ? rideTypeData.find((element) => {
                                        return element?.value === rideTypeField?.value;
                                    }) : ""}
                                    onChange={handleRideTypeSelectChange}
                                    placeholder="Select Ride Type"
                                    options={rideTypeData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.rideType?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Booking Source</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <Select
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={bookingSourceField?.value ? bookingSourceData.find((element) => {
                                        return element?.value === bookingSourceField?.value;
                                    }) : ""}
                                    onChange={handleBookingSourceSelectChange}
                                    placeholder="Select Booking Source"
                                    options={bookingSourceData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.bookingSource?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Wallet-Ops</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <Select
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={
                                    creditOrDebitField?.value ?
                                         creditOrDebitData.find((element) => {
                                            return element?.value === creditOrDebitField?.value;
                                        })
                                        : ''
                                    }
                                    onChange={handlecreditOrDebitSelectChange}
                                    placeholder="Select Wallet-Ops Type"
                                    options={creditOrDebitData}
                                />
                            </div>
                            <span style={{ color: "red" }}>
                            {errors?.creditOrDebit?.message}
                            </span>
                        </Col>
                    </FormGroup>
                </Row>
                {/* <Row>
                    <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
                </Row>
                {isAdvanced ? <Row>
                </Row> : null} */}


                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        {couponObj?.id ? "Update" : "Create"}
                    </button>
                </div>
            </Form>
        </CommonModal>
    )
}

export default CouponInput